module.exports = __webpack_public_path__ + "img/Image - Header 5@2x.ce392416.png";